export default __webpack_public_path__ + "static/defi-alliance@2x-d733b550dff1bf61fe1404d2bead41f8.png";